import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';

import './MessagesEmptyState.styles.scss';
import './MessagesEmptyState.styles.responsive.scss';

type MessagesEmptyStateProps = {
  className?: string;
  text: string;
  description?: string;
  imageSrc?: string;
};

const MessagesEmptyState: React.FC<MessagesEmptyStateProps> = (props) => {
  const { className, text, description, imageSrc } = props;

  const classes = classNames('messages-empty-state', className);

  return (
    <div className={classes}>
      {imageSrc && <ResolveImage src={imageSrc} asIllustration />}

      <p>{text}</p>

      {description && <p className="description">{description}</p>}
    </div>
  );
};

export default MessagesEmptyState;
